import styled from "styled-components";

const Navbar = styled.div`
  font-family: "Poppins";
  background-color: #0f3137;

  .wrapper {
    transform: translateY(-100%);
    transition: 1s ease;
    display: flex;
    justify-content: space-between;
    padding-left: 1rem;
    padding-right: 2rem;
    flex-wrap: wrap;
    align-items: center;

    margin: 0.4em 0;
    &.fadeIn {
      transform: translateY(0%);
      opacity: 1;
    }
    @media (max-width: 1700px) {
      // height: 5rem;
    }
    .logo_div {
      flex: 0.2;
      width: 22%;
      text-align: center;
      margin-bottom: 1px;
      cursor: pointer;
      .logo {
        padding: 1%;
        margin: 1px auto 1px;
        @media (max-width: 1700px) {
          height: auto;
        }
        @media (max-width: 600px) {
          flex: 0.8;
          width: 80%;
          height: 3rem;
          margin-left: 22vw;
          margin-right: auto;
          object-fit: contain;
        }
      }
      @media (max-width: 1700px) {
        flex: 0.3;
      }
      @media (max-width: 1300px) {
        flex: 0.15;
      }
      @media (max-width: 1000px) {
        flex: 0.18;
      }
      @media (max-width: 600px) {
        flex: 0.8;
      }
    }
    .links_div {
      display: flex;
      width: 55%;
      flex-wrap: wrap;
      justify-content: space-around;
      @media (max-width: 1300px) {
        display: none;
      }
      align-items: center;
      .link {
        text-decoration: none;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        cursor: pointer;
        color: white;
        margin: 0 1vw 0;
        letter-spacing: 3.2px;
        @media (max-width: 1700px) {
          font-size: 13px;
          font-weight: 500;
          margin: 0 0vw 0;
        }
        &:hover {
          color: #fedd57;
        }
        .link-drop {
          font-family: "Poppins";
          text-decoration: none;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 24px;
          color: white;
          margin: 0 1vw 0;
          letter-spacing: 3.2px;
          @media (max-width: 1700px) {
            font-size: 13px;
            font-weight: 500;
            margin: 0 0vw 0;
          }
          &:hover {
            color: #fedd57;
          }
          &:focus {
            background: #0f3137;
            outline: 0;
          }
          &:active {
            outline: none;
            border: none;
          }
        }
      }
      @media (max-width: 1024px) {
        display: none;
      }
    }
    .toggleButton_div {
      width: 60%;
      text-align: center;
      display: none;
      @media (max-width: 1024px) {
        display: block;
      }
      @media (max-width: 950px) {
        width: 20%;
      }
    }

    .buyButton_div {
      text-align: right;
      display: block;
      flex: 0.2;

      @media (max-width: 1600px) {
        width: 20%;
        display: flex;
        justify-content: space-around;
        padding-right: 1rem;
      }
      @media (max-width: 900px) {
        // width: 25%;
        flex: 0.28;
        padding-left: 2rem;
        justify-content: space-between;
      }
      @media (max-width: 600px) {
        flex: 0.32;
        padding-left: 1rem;
      }

      @media (max-width: 500px) {
        flex: 0.38;
        padding-left: 1rem;
      }
      @media (max-width: 380px) {
        flex: 0.4;
        padding-left: 1rem;
      }
      .none {
        display: none;
      }
      .buyButton {
        @media (max-width: 650px) {
          display: none;
        }
        width: 11rem;
        height: 3.2rem;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 27px;
        letter-spacing: 0em;
        text-align: left;
        border-radius: 10px;
        color: #1c454c;
        background-color: #fdcd0b;
        transition: transform 0.3s;
        &:hover {
          background-color: #fdd224;
          transform: scale(1.1);
        }

        @media (max-width: 1700px) {
          width: 9rem;
          height: 2.8rem;
          font-size: 16px;
        }
        @media (max-width: 900px) {
          font-size: 13px;
          line-height: 15px;
          // width: 15rem;
        }
        @media (max-width: 1024px) {
          font-size: 15px;
          width: 8rem;
          line-height: 19px;
        }
        @media (max-width: 500px) {
          font-size: 10px;
          padding-left: 1rem;
          height: 2.1rem;
        }
      }
      .hamBtnDiv {
        display: none;
        margin-left: auto;
        @media (max-width: 1600px) {
          display: block;
        }
        @media (max-width: 600px) {
          display: block;
          width: 20px;
          height: 20px;
          margin-bottom: 1rem;
        }
        @media (max-width: 400px) {
          display: block;
          object-fit: contain;
          margin-top: auto;
          margin-bottom: auto;
          margin-bottom: 1rem;
        }
      }
    }
  }
  .sm {
    @media (min-width: 1300px) {
      display: none !important;
    }
  }
`;

export default Navbar;
